<form [formGroup]="form">
  <div class="sections">
    <section>
      <mat-form-field appearance="outline">
        <mat-label>Version</mat-label>
        <input matInput formControlName="version" placeholder="e.g. 1.2.0" />
        <mat-error *ngIf="form.get('version')?.hasError('required')">Version is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <input matInput formControlName="date" placeholder="YYYY-MM-DD" />
        <mat-error *ngIf="form.get('date')?.hasError('required')">Date is required</mat-error>
        <mat-error *ngIf="form.get('date')?.hasError('pattern')">Date must be in YYYY-MM-DD format</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type">
          @for (t of types; track t.value) {
            <mat-option [value]="t.value">{{ t.label }}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="form.get('type')?.hasError('required')">Type is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
        <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="3"></textarea>
        <mat-error *ngIf="form.get('description')?.hasError('required')">Description is required</mat-error>
      </mat-form-field>
    </section>
  </div>

  <div class="actions">
    <button mat-flat-button (click)="onCancel()">Cancel</button>
    <button color="primary" [disabled]="!form.valid" mat-flat-button (click)="onAdd()">Add</button>
  </div>
</form>
